import React from "react"
import types from "prop-types"
import { activityHubSubmissionAndTaskPath } from "utils/routeHelpers"

const TaskLink = ({ formSubmissionSlug, task }) => {
  const { id, title } = task

  return (
    <a className="link-text" target="_blank" href={activityHubSubmissionAndTaskPath(formSubmissionSlug, id)} rel="noreferrer">{title}</a>
  )
}

TaskLink.propTypes = {
  formSubmissionSlug: types.string.isRequired,
  task: types.object.isRequired,
}

export default TaskLink
